// The restaurant's chats in the platform agent's panel (D4). Wording from the Amigo design's copy sheet (Chats, Chats
// none); `status` are the chat statuses of docs/platform-agent/contracts.md §6, `who.kinds` who started a chat.
export default {
  title: 'Chat',
  new_chat: 'Nuova chat',
  note: {
    team: 'Tutte le chat su {{restaurant}}: le tue, quelle del tuo team e quelle del ristorante.',
    own: 'Le tue chat su {{restaurant}}.',
  },
  log: 'Tutte le richieste nel registro di Amigo',
  days: {
    today: 'Oggi',
    yesterday: 'Ieri',
    earlier: 'Precedenti',
  },
  who: {
    you: 'Tu',
    kinds: {
      foodamigos: 'FoodAmigos',
      owner: 'Titolare',
      staff: 'Staff',
      partner: 'Partner',
    },
  },
  status: {
    done: 'Completato',
    answered: 'Risposto',
    waiting: 'In attesa di approvazione',
    partial: '{{applied}} di {{total}} applicati',
    rejected: 'Rifiutato',
    not_yet: 'Non ancora possibile',
    failed: 'Non riuscito',
  },
  none: {
    title: 'Ancora nessuna chat per {{restaurant}}',
    text: 'Le chat avviate qui restano qui, così puoi riprenderle in qualsiasi momento.',
  },
  loading: 'Caricamento delle chat…',
  loading_more: 'Caricamento di altre chat…',
  load_failed: 'Impossibile caricare le chat.',
  retry: 'Riprova',
  // A chat with answers the person hasn't read (QA45), before its last line.
  new_answers_one: 'Nuova risposta:',
  new_answers_other: 'Nuove risposte:',
};
